import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { api } from './cliente';
import { chaves } from './query';
import type { Integrador } from './tipos';

/* Integrador = a empresa do usuário. É onde moram custos, despesas,
 * sazonalidade e indicadores — tudo que as etapas de configuração escrevem. */

export function useIntegrador() {
  return useQuery({
    queryKey: chaves.integrador,
    queryFn: () => api.obter<Integrador | null>('/integradores/meu'),
  });
}

/**
 * Salva um PEDAÇO do integrador (PATCH).
 *
 * Parcial de propósito: cada etapa do funil grava só a sua parte. Mandar o
 * objeto inteiro faria a tela de despesas sobrescrever a de custos com o que
 * ela leu quando abriu.
 */
export function useSalvarIntegrador() {
  const clienteQuery = useQueryClient();
  return useMutation({
    mutationFn: (parcial: Partial<Integrador>) =>
      api.ajustar<Integrador>('/integradores/meu', parcial),
    onSuccess: (integrador) => {
      clienteQuery.setQueryData(chaves.integrador, integrador);
      // Mudou custo/despesa/meta: qualquer análise em cache está velha.
      void clienteQuery.invalidateQueries({ queryKey: ['calculo'] });
    },
  });
}
